import axios from "axios";
import { EventEmitter } from "eventemitter3";

export default class MergeService extends EventEmitter {
  constructor(url, headers) {
    super();
    this.url = url;
    this.headers = headers || {};
  }

  execute(fileId, uploadId, blockNum, cancelToken) {
    const { url, headers } = this;
    const data = { fileId, uploadId, blockNum };
    axios
      .post(url, data, { headers, cancelToken })
      .then((e) => {
        if (e.data.code !== 200) {
          this.emit("error", new Error(e.data.message));
          return;
        }
        const fileId = e.data.data.fileId;
        this.emit("complete", fileId);
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          return this.emit("abort");
        }
        this.emit("error", err);
      });
  }
}
